import React, { useState, useEffect } from 'react'
import '../../../pages/proposal/styles.less'
import { Table, ButtonGroup, IconButton, Icon, Modal, Button } from 'rsuite'

export default function ProjectManageStructureTableForm({
  schema,
  handleDelete,
  handleEdit,
  isEdit,
}) {
  const { Column, HeaderCell, Cell } = Table
  const [isdelete, setIsdelete] = useState(false)
  const [deleteIndex, setDeleteIndex] = useState()
  const [name, setName] = useState()

  const projectmanageInputForm = () => {
    return (
      <div>
        <Table autoHeight headerHeight={56} data={schema.value} className="project-management-structure-table">
          <Column width={120} align="center">
            <HeaderCell className="project-management-structure-header-nowrap">ลำดับ</HeaderCell>
            <Cell>
              {(rowData, index) => {
                return <span>{index + 1}</span>
              }}
            </Cell>
          </Column>
          <Column width={190} resizable>
            <HeaderCell>บทบาทหน้าที่</HeaderCell>
            <Cell>
              {(rowData) => {
                if (rowData.otherRoleName && rowData.roleCode == '6') {
                  return <span>{rowData.otherRoleName}</span>
                } else return <span>{rowData.roleLabel}</span>
              }}
            </Cell>
          </Column>

          <Column width={200} resizable>
            <HeaderCell>ชื่อ-นามสกุล</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <span>
                    {rowData.honorificLabel + ' ' + rowData.firstName + ' ' + rowData.lastName}
                  </span>
                )
              }}
            </Cell>
          </Column>

          <Column width={150} resizable>
            <HeaderCell>เบอร์โทรศัพท์</HeaderCell>
            <Cell>
              {(rowData) => {
                console.log(rowData)
                return <span>{rowData.telephone}</span>
              }}
            </Cell>
          </Column>

          <Column width={250} resizable>
            <HeaderCell>อีเมล์</HeaderCell>
            <Cell>
              {(rowData) => {
                return <span>{rowData.email}</span>
              }}
            </Cell>
          </Column>

          {isEdit && (
            <Column width={200} align="center" fixed="right">
              <HeaderCell></HeaderCell>

              <Cell>
                {(rowData, index) => {
                  return (
                    rowData.roleCode != '1' && (
                      <ButtonGroup style={{ marginTop: '-4%' }}>
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-edit"
                          icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                          onClick={() => handleEdit(rowData, index)}
                        >
                          แก้ไข
                        </IconButton>
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                          onClick={() => {
                            setIsdelete(true)
                            setDeleteIndex(index)
                            setName(
                              rowData.honorificLabel +
                                ' ' +
                                rowData.firstName +
                                ' ' +
                                rowData.lastName
                            )
                          }}
                        >
                          ลบ
                        </IconButton>
                      </ButtonGroup>
                    )
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>

        <Modal
          show={isdelete}
          onHide={(e) => {
            setIsdelete(false)
          }}
        >
          <Modal.Header>
            <Modal.Title>ยืนยันการลบ</Modal.Title>
          </Modal.Header>
          <Modal.Body>{'ยืนยันการลบ ' + name}</Modal.Body>
          <Modal.Footer>
            <Button
              onClick={(e) => {
                handleDelete(deleteIndex)
                setIsdelete(false)
              }}
              appearance="primary"
            >
              ลบ
            </Button>
            <Button
              onClick={(e) => {
                setIsdelete(false)
                setDeleteIndex('')
              }}
              appearance="subtle"
            >
              ยกเลิก
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }

  return <>{projectmanageInputForm()}</>
}
